import type { TestRunVersionProgress } from "src/api/endpoints";
import { TestRunCard } from "src/unifiedCopilot/runs/TestRunCard";
import { useTestRunProgress } from "src/unifiedCopilot/runs/useTestRunProgress";

/**
 * A dataset test run followed live from the run API. Used both while the
 * runner is still inside the `run_flow` tool call and afterwards, when the
 * tool handed back a run that had not settled yet.
 */
export const TestRunProgressCard: React.FC<{
  testRunId: string;
  flowVersionId: string | null;
  /** Counts from the session payload, shown until the run API answers. */
  initialProgress?: TestRunVersionProgress | null;
  dataLoc?: string;
  /** Shown once the run has results to open, e.g. a link to them. */
  action?: React.ReactNode;
}> = ({
  testRunId,
  flowVersionId,
  initialProgress = null,
  dataLoc,
  action,
}) => {
  const { state } = useTestRunProgress({ testRunId, flowVersionId });

  return (
    <TestRunCard
      action={action}
      dataLoc={dataLoc}
      progress={state.progress ?? initialProgress}
      status={state.status}
    />
  );
};
